const scope = "attributes";
export default scope;
